import { render } from "./IgniteFaq.vue?vue&type=template&id=935e0422"
import script from "./IgniteFaq.vue?vue&type=script&lang=js"
export * from "./IgniteFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__